export enum JoinEventErrors {
  EVENT_ENDED = "server:event.ended",
  EVENT_FULL = "EVENT_FULL",
  EVENT_PRIVATE = "server:unsafe.private.event",
  EVENT_UPCOMING = "server:event.not.started",
}

export enum GuestUsageErrors {
  GUEST_LIMIT_EXCEEDED = "server:addon.guest.limit.overdue.exceed",
  NO_ADDON = "server:agency.no.addon",
}
